import { generateMockId } from '@gp/utils/common';
import { initializeTechnicalModuleValues } from '../../utils';
import { BoolFlag } from '@gp/enums/common';
import { TECHNICAL_MODULE_KEYS, TECHNICAL_MODULE_NAME_MAPPING } from '../../const';

import type {
  IDynamicFormField,
  IDynamicFormFieldValidator,
  IDynamicFormFieldValidation,
} from '@gp/components/DynamicForm/types';
import type { IDynamicFormControl } from '@gp/components/DynamicForm/components/FormControl/types';
import type { ProjectTechnicalModule } from '@gp/enums/project';

// 字段集合
export const FIELDS: IDynamicFormField[] = TECHNICAL_MODULE_KEYS.map((key) => {
  return {
    key,
    type: 'customizeTagSelect',
    required: false,
    label: TECHNICAL_MODULE_NAME_MAPPING[key],
  };
});

// 字段控件映射
export const CONTROLS: Record<
ProjectTechnicalModule,
Partial<IDynamicFormControl>
> = initializeTechnicalModuleValues<IDynamicFormControl>(
  {
    loading: true,
    ignoreCase: true,
    options: [],
    deletable: (option?: IGPSelectOption | null) => {
      const { data } = option || {};
      const { is_public: isPublic } = data || {};
      return isPublic === BoolFlag.False;
    },
    generateCustomizeAddOptionValue: () => generateMockId(),
    generateCustomizeAddOptionData: (value, text) => {
      return { id: value || '', tag: text || '', is_public: BoolFlag.False, update_time: '' };
    },
  },
  (moduleKey) => {
    return { placeholder: `Please select ${TECHNICAL_MODULE_NAME_MAPPING[moduleKey]}` };
  },
);

// 字段检验器配置
export const VALIDATORS: Record<ProjectTechnicalModule, IDynamicFormFieldValidator> = initializeTechnicalModuleValues({
  required: false,
});

// 字段校验结果信息映射
export const VALIDATIONS: Record<ProjectTechnicalModule, IDynamicFormFieldValidation> = initializeTechnicalModuleValues(
  { status: 'success', message: '' },
);
